import { render, staticRenderFns } from "./arvioinnit-erikoistuva.vue?vue&type=template&id=e8b35492&scoped=true&"
import script from "./arvioinnit-erikoistuva.vue?vue&type=script&lang=ts&"
export * from "./arvioinnit-erikoistuva.vue?vue&type=script&lang=ts&"
import style0 from "./arvioinnit-erikoistuva.vue?vue&type=style&index=0&id=e8b35492&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b35492",
  null
  
)

export default component.exports